export default __webpack_public_path__ + "static/media/file-zip.2642ae2e.svg";